var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"blank-widget",attrs:{"justify":"center"}},[_c('change-widget',{attrs:{"position":_vm.currentPosition}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }